import * as React from "react";
import { Link } from "react-router";
import { trackStructured } from "../../utils/TrackingUtil";
type Props = {
	article: LinkableArticle;
	children?: JSX.Element | JSX.Element[] | null;
};
interface LinkableArticle {
	readonly bundleId: string;
	readonly description: string;
}
export function ArticleLink(props: Props) {
	//this is bad :( we should either have articleId/variantNumber/bundleNumber or be able to link with the full ID
	const bundleId = props.article.bundleId.split("@")[0];
	const articleId = bundleId.substring(0, bundleId.length - 8);
	const variantNumber = bundleId.slice(-8, -4);
	const bundleNumber = bundleId.slice(-4);
	const articleTitle = props.article.description || props.article.bundleId;
	const pathname =
		"/pv/" +
		encodeURIComponent(articleId) +
		"/" +
		encodeURIComponent(variantNumber) +
		"/" +
		encodeURIComponent(bundleNumber);

	function track() {
		trackStructured("cart.item.goToPv", {
			tags: {
				bettyBundleId: props.article.bundleId,
				mcw: "true",
			},
		});
	}

	return (
		<Link
			title={articleTitle}
			className="h4"
			to={{
				pathname,
			}}
			onClick={track}
		>
			{articleTitle}
		</Link>
	);
}
